import { getPlantStatus, sendEmail } from '@apis'

export default async function checkPlantStatus(_plantId) {
  const res = await getPlantStatus(_plantId)
  const data = res?.data?.result

  if (data && res.codeHTTP === 200 && data.status !== 'Ok') {
    console.log('Plant status is not OK')
  }
}
